// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1NrPd","icons":"styles_icons__Wv1tf","checkbox":"styles_checkbox__27sOZ"};